export default function ClockIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width="24"
      height="24"
      className={className}
    >
      <path
        fill="#ff5876"
        d="M512 256c0-3.11-.056-6.208-.165-9.291C506.944 109.628 394.275 0 256 0S5.056 109.628.166 246.709C.056 249.792 0 252.89 0 256c0 141.385 131.502 246.71 256 246.71 126.754 0 256-105.325 256-246.71z"
      />
      <path
        fill="#e6485d"
        d="M256 493.419c-138.273 0-250.922-109.631-255.814-246.71A258.192 258.192 0 0 0 0 256c0 141.385 114.615 256 256 256s256-114.615 256-256c0-3.112-.075-6.205-.185-9.29C506.922 383.789 394.273 493.419 256 493.419z"
      />
      <path
        fill="#e4eef9"
        d="M469.419 246.709C464.555 133.042 370.865 42.382 256 42.382S47.445 133.042 42.581 246.709C42.449 249.79 42.58 456.03 256 456.03s213.551-206.24 213.419-209.321z"
      />
      <path
        fill="#d5e0f2"
        d="M256 451.037c-114.864 0-208.539-90.662-213.405-204.328a216.93 216.93 0 0 0-.213 9.29c0 117.978 95.64 213.618 213.618 213.618S469.618 373.978 469.618 256c0-3.114-.082-6.209-.213-9.29C464.539 360.376 370.864 451.037 256 451.037z"
      />
      <path
        fill="#405b6c"
        d="M333.595 181.05c-6.089-6.005-15.893-5.938-21.897.15l-36.334 36.837 3.651 17.537 16.972 5.654 37.759-38.281c6.004-6.088 5.937-15.892-.151-21.897zM234.082 219.447l-82.402-73.432c-6.385-5.69-16.172-5.126-21.861 1.259-5.689 6.384-5.126 16.172 1.259 21.861l84.025 74.878 17.509-5.84z"
      />
      <path
        fill="#86dcff"
        d="M365.636 355.837a7.712 7.712 0 0 1-4.976-1.814l-98.073-82.378a7.742 7.742 0 0 1 9.959-11.856l98.073 82.379a7.742 7.742 0 0 1-4.983 13.669z"
      />
      <path
        fill="#2d4456"
        d="m215.103 244.013 14.46 12.886 18.57-6.31-1.007-19.519-13.043-11.623c-9.075 5.453-15.944 14.19-18.98 24.566zM275.363 218.038l-12.294 12.464v24.466h19.366l13.552-13.739c-3.724-10.076-11.151-18.349-20.624-23.191z"
      />
      <path
        fill="#ff5876"
        d="M280.783 246.708c-3.762-10.03-13.439-17.169-24.783-17.169s-21.021 7.139-24.783 17.169c-1.084 2.891-.072 26.462 24.783 26.462s25.867-23.571 24.783-26.462z"
      />
      <path
        fill="#e6485d"
        d="M256 263.88c-11.344 0-21.017-7.14-24.779-17.17a26.381 26.381 0 0 0-1.682 9.29c0 14.614 11.847 26.46 26.46 26.46 14.614 0 26.46-11.847 26.46-26.46 0-3.27-.597-6.399-1.681-9.29-3.761 10.029-13.434 17.17-24.778 17.17z"
      />
      <g fill="#405b6c">
        <path d="M263.757 93.573V69.546a7.757 7.757 0 0 0-15.514 0v24.027c0 4.284 3.472 7.757 7.757 7.757s7.757-3.473 7.757-7.757zM248.243 418.427v24.027c0 4.284 3.472 7.757 7.757 7.757s7.757-3.473 7.757-7.757v-24.027a7.757 7.757 0 0 0-15.514 0zM442.454 263.757a7.757 7.757 0 0 0 0-15.514h-24.027a7.757 7.757 0 0 0 0 15.514zM69.546 248.243c-4.285 0-7.757 3.473-7.757 7.757s3.472 7.757 7.757 7.757h24.027a7.757 7.757 0 0 0 0-15.514z" />
      </g>
    </svg>
  );
}
